// 對應 CustomizeModel.FormType的列舉
export class PageType {
  static get Item () {
    return 1
  }
  static get GroupPoint () {
    return 2
  }
  static get Customer () {
    return 3
  }
  static get SerialNumber () {
    return 4
  }
  static get InitResume () {
    return 5
  }
  static get InitMonth () {
    return 6
  }
  static get Point () {
    return 7
  }
  static get Bom () {
    return 8
  }
  static get VirtualBom () {
    return 9
  }
  static get MonthBom () {
    return 10
  }
  static get User () {
    return 11
  }
  static get EngineerStock () {
    return 12
  }
  static get SpecialNeed () {
    return 13
  }
  static get CheckExcel () {
    return 14
  }
  static get CustomerRepair () {
    return 15
  }
  static get Notice () {
    return 16
  }
  static get Acceptance () {
    return 17
  }
  static get Resume () {
    return 18
  }
  static get Fix () {
    return 19
  }
  static get Repair () {
    return 20
  }
  static get Month () {
    return 21
  }
  static get Settle () {
    return 22
  }
  static get Discount () {
    return 23
  }
  static get Overage () {
    return 24
  }
  static get Quotation () {
    return 25
  }
  static get QuotationChangeDetail () {
    return 26
  }
  static get Merge () {
    return 27
  }
  static get MonthQuotation () {
    return 28
  }
  static get ChangeDetail () {
    return 29
  }
  static get EngineerNotWork () {
    return 30
  }
  static get EngineerNotDone () {
    return 31
  }
  static get EngineerDone () {
    return 32
  }
  static get Personal () {
    return 33
  }
  static get Login () {
    return 34
  }
  static get UpdateCustomerRepair () {
    return 35
  }
  static get AcceptanceTryInstallDivide () {
    return 36
  }
  static get InstallPosition () {
    return 37
  }
  static get InstallPositionApply () {
    return 38
  }
  static get TransferOrder () {
    return 39
  }

  static PageTypeName (pageType) {
    let tmpType = parseInt(pageType)
    let type = isNaN(tmpType) ? -1 : tmpType
    let name = ''
    switch (type) {
      case 1:
        name = '品號'
        break
      case 2:
        name = '點數品號'
        break
      case 3:
        name = '客戶資料'
        break
      case 4:
        name = '產品序號'
        break
      case 5:
        name = '初始化履歷卡'
        break
      case 6:
        name = '初始化月租'
        break
      case 7:
        name = '點數管理'
        break
      case 8:
        name = 'BOM'
        break
      case 9:
        name = '虛擬BOM'
        break
      case 10:
        name = '月租BOM'
        break
      case 11:
        name = '人員管理'
        break
      case 12:
        name = '工程師綁庫別'
        break
      case 13:
        name = '特殊需求管理'
        break
      case 14:
        name = '檢查Excel'
        break
      case 15:
        name = '客戶單價明細表'
        break
      case 16:
        name = '安裝通知單'
        break
      case 17:
        name = '安裝驗收單'
        break
      case 18:
        name = '履歷卡'
        break
      case 19:
        name = '叫修單'
        break
      case 20:
        name = '維修單'
        break
      case 21:
        name = '客戶月租檔'
        break
      case 22:
        name = '月租批次轉銷貨單'
        break
      case 23:
        name = '月租折扣'
        break
      case 24:
        name = '月租預繳'
        break
      case 25:
        name = '報價單'
        break
      case 26:
        name = '報價單-變更車牌、客代'
        break
      case 27:
        name = '合併報價單'
        break
      case 28:
        name = '模擬月租'
        break
      case 29:
        name = '模擬月租-變更車牌、客代'
        break
      case 30:
        name = '工單-未派'
        break
      case 31:
        name = '工單-回報'
        break
      case 32:
        name = '工單-完工'
        break
      case 33:
        name = '個人資料'
        break
      case 34:
        name = '登入'
        break
      case 35:
        name = '變更單價明細表'
        break
      case 36:
        name = '安裝驗收單劃分安裝、拆機'
        break
      case 37:
        name = '安裝位置'
        break
      case 38:
        name = '安裝位置申請單'
        break
      case 39:
        name = '倉管核對'
        break
    }
    return name
  }
}
